import { atom } from 'jotai';

export const selectedSessionIdsAtom = atom<string[]>([]);
export const lastSelectedIndexAtom = atom<number | null>(null);
export const isSessionsSelectedAllAtom = atom<boolean>(false);
